import styled from 'styled-components/macro'
import { Select } from '@scuf/common'

export const Form = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
`

export const FormContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
`

export const FormButtons = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-top: 1rem;
  justify-content: flex-end;
`

export const Row = styled.div`
  & + & {
    margin-top: 1rem;
  }
`

export const TableContainer = styled(Row)`
  flex: 1;
`

export const StyledSelect = styled(Select)`
  width: auto !important;
  max-width: 50%;
`
